/* eslint-disable jsx-a11y/control-has-associated-label */
/**
 *  @typedef {import('../../interfaces/components/dropdownAudio.interface').IDropdownAudioOption} IDropdownAudioOption
 */
import React from 'react';
import { classNames } from 'primereact/utils';
import AUIIcon from '@ancert/aui-icon';
import { OPTIONS_VALUE } from './options';

/**
 * @param {object} props
 * @param {IDropdownAudioOption} props.option
 * @param {*} props.inputUploadRef
 * @returns
 */
const optionTemplate = ({ option, inputUploadRef }) => {
  if (option.value === OPTIONS_VALUE.SELECCIONAR) {
    return (
      <button
        type="button"
        className="c-sii-dropdown-audio__template"
        onClick={() => inputUploadRef.current.click()}
        aria-hidden
      >
        <AUIIcon icon="upload" color="blue" />
        {option.label}
      </button>
    );
  }
  return (
    <div className="c-sii-dropdown-audio__template">
      <AUIIcon icon={option.value === OPTIONS_VALUE.SELECCIONAR ? 'upload' : 'micro'} color="blue" />
      {option.label}
    </div>
  );
};

const valueTemplate = (
  <div className="c-sii-dropdown-audio__template">
    <AUIIcon icon="audio" />
    Seleccionar o grabar archivo de audio
  </div>
);

/**
 *
 * @param {object} props
 * @param {string} props.nombreAudio
 * @param {boolean} [props.readOnly]
 * @param {*} props.onClickDelete
 * @returns
 */
const dropdownSelected = ({ nombreAudio, onClickDelete, readOnly = false }) => {
  const className = classNames('c-sii-dropdown-audio__selected', {
    [`c-sii-dropdown-audio__selected--readOnly`]: readOnly,
  });
  return (
    <div className={className}>
      <span className="c-sii-dropdown-audio__selected__name">
        <AUIIcon icon="audio" />
        {nombreAudio}
      </span>
      {!readOnly && (
        <button type="button" onClick={onClickDelete}>
          <AUIIcon icon="binOutline" />
        </button>
      )}
    </div>
  );
};
export { optionTemplate, valueTemplate, dropdownSelected };
